function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".hero-box_svg__hero-box-polyline{stroke-dasharray:1000;stroke-dashoffset:1000;animation:dash 2s linear forwards}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hero-box_svg__Explore",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero-box_svg__Hero-Images",
  transform: "translate(0 -2715)",
  stroke: "#F01919",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("g", {
  id: "hero-box_svg__5-0-Hero-Photo",
  transform: "translate(0 2715)"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero-box_svg__5-0-hero-box"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero-box_svg__Box",
  transform: "translate(1213 28)"
}, /*#__PURE__*/React.createElement("path", {
  id: "hero-box_svg__Rectangle-Copy-8",
  className: "hero-box_svg__hero-box-polyline",
  d: "M126 0h104v256H126.533"
}), /*#__PURE__*/React.createElement("path", {
  id: "hero-box_svg__Rectangle-Copy-9",
  className: "hero-box_svg__hero-box-polyline",
  transform: "matrix(-1 0 0 1 104 0)",
  d: "M0 0h104v256H.533"
}))))));

var SvgHeroBox = function SvgHeroBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 360,
    viewBox: "0 0 2000 360"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/hero-box.fcec2c39.svg";
export { SvgHeroBox as ReactComponent };